import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Pin = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 16C12 11.5425 14 8.20914 14 6C14 2.68629 11.3137 0 8 0C4.68629 0 2 2.68629 2 6C2 8.20914 4 11.5425 8 16ZM3 6C3 3.23858 5.23858 1 8 1C10.7614 1 13 3.23858 13 6C13 7.75446 11.3433 10.6328 8 14.4887C4.65668 10.6328 3 7.75446 3 6ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8ZM7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6Z"
  />,
  'Pin'
)

export default Pin
